<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  [isEmpty]="!(tableData$ | async)?.length"
  [emptyTitle]="'noTreatments' | translate"
  [emptyDescription]="'noTreatmentsInAdvice' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  [primaryActionText]="'printReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
>
  <agr-print-page
    [relatedPeople]="relatedPeople$ | async"
    [marginLeft]="true"
    [footerText]="'fertilizationWarningFooter' | translate"
    [showPageNumber]="false"
  >
    <div class="spacing--padding-bottom">
      <app-general-info></app-general-info>
    </div>
    <div class="spacing--margin-half-vertical">
      <app-nutrient-balance-table
        [tableReportData$]="sortedTableData$"
      ></app-nutrient-balance-table>
    </div>
  </agr-print-page>
</agr-page-detail>
